// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qo-9";
export var arrowButtonContainer = "_qo-5";
export var arrowButtonIcon = "_qo-6";
export var carouselArrowButton = "_qo-2";
export var carouselElementContainer = "_qo-1";
export var currentSlide = "_qo-8";
export var left = "_qo-3";
export var otherSlide = "_qo-a";
export var productCarouselContainer = "_qo-0";
export var right = "_qo-4";
export var sliderOverflow = "_qo-7";